import { GridCustomToolBarButton, ToolBarStandardButton, ToolBarStandardButtonType } from "../core/components/toolBar";
import { Config } from "../core/config/config";
import { Grid } from "../core/components/grid";
import { Helper } from "../core/util/helper";
import { Dialog, DialogProps } from "../core/components/dialog";
import { FieldInstance } from "../core/components/field";
import { TextBox } from "../core/components/textBox";
import { ComponentHelper } from "../core/util/componentHelper";
import { DialogHelper } from "../core/util/dialogHelper";
import { CheckBox } from "../core/components/checkBox"
import { IsNumericTextBox } from "../core/components/isNumericTextBox";
import { MetaDataHelper } from "../core/util/metaDataHelper";
import { FullHeightContainer } from "../core/components/FullHeighContainer";
import { General } from "../../siteManagement/general";
import { SheetEventType } from "../../siteManagement/sheet";
import { CRKeyValuePair, CRQuestionContext, CRQuestionEntity, DataTypes, CRTranslation } from "./crQuestion"
import { CRTranslationsDialog } from "./crTranslationsDialog"
import { NotificationHelper } from "../core/util/notificationHelper";
import React from "react";
export default class PossibleValuesGrid extends React.Component<PossibleValuesGridProps, PossibleValuesGridState> {
    private _factory = ComponentHelper.createFactory();
    private _gridOptions: any;
    private _amountInvalidDataItems: number;
    private _oldId: number;
    private _enabled: boolean;
    private _dialogProps: DialogProps = {
        title: Config.translations.editLabel,
        actions: [
            {
                label: Config.translations.cancel,
                action: () => { }
            },
            {
                label: Config.translations.ok,
                action: () => {
                    const isOk = this._checkData();
                    if (isOk) {
                        this._updateGridData(this.state.currentDataItem);
                    } else {
                        NotificationHelper.showWarningMessage(Helper.getTranslation("Standard.PflichtfeldAllgemein"))
                    }
                    return isOk;
                },
                primary: true
            }
        ],
        afterClose: () => {
            this.setState({ dialogOpen: false });
        },
        width: 500
    };

    constructor(props) {
        super(props);
        this._amountInvalidDataItems = 0;
        this._setEvents();
        this.state = {
            gridData: null,
            currentDataType: DataTypes.int,
            dialogOpen: false,
            currentDataItem: null
        };
    }

    private _afterGridDataChange = () => {
        let isValid: boolean = true;
        let newValues: CRKeyValuePair[] = [];
        for (let i = 0; i < this.state.gridData.length; i++) {
            if (!this.state.gridData[i].isValid) {
                isValid = false;
            }
            newValues.push({
                Id: this.state.gridData[i].Id,
                Value: this.state.gridData[i].Value,
                DisplayText: this.state.gridData[i].DisplayText,
                Translations: this.state.gridData[i].Translations
            });
        }
        MetaDataHelper.setFieldValue(this.props.entity, "entity.PossibleValues", newValues);
        let sheet = General.Sheet.Manager.getTopMostSheet();
        sheet.trigger(SheetEventType.Custom, { command: "possibleValuesChanged", isValid: isValid, value: this.state.gridData });
    }

    private _changeGridStatus = (status: boolean) => {
        this._enabled = status;
        this.setState({});
    }

    private _checkData = () => {
        const item = this.state.currentDataItem;
        return Helper.hasValue(item) && !Helper.isNullOrEmpty(item.Id);
    }

    private _updateGridData = (dataItem: CRKeyValue) => {
        dataItem.isValid = this._isValidValue(dataItem.Value, this.state.currentDataType);
        let gridData = this.state.gridData.slice(0);
        if (dataItem.isValid) {
            if (Helper.hasValue(this._oldId)) {
                gridData[this._oldId] = dataItem;
            } else {
                gridData.push(dataItem);
            }
        }
        const counterObj: any = {};
        let isValid = true;
        for (const i of gridData) {
            counterObj[i.Id] = (counterObj[i.Id] || 0) + 1

            if (counterObj[i.Id] > 1) {
                isValid = false;
                break;
            }
        }

        if (isValid) {
            this.setState({ gridData: gridData }, () => { this._afterGridDataChange() });
        } else {
            NotificationHelper.showErrorMessage("Id has to be unique.");
            this.setState({}, () => { this._afterGridDataChange() });
        }
    }

    private _updateDataType = (ordinal: number) => {
        this._amountInvalidDataItems = 0;
        let oldGridData = this.state.gridData;
        let newGridData: CRKeyValue[] = [];

        if (ordinal <= DataTypes.boolean) {
            for (let i = 0; i < oldGridData.length; i++) {
                let isValid = this._isValidValue(oldGridData[i].Value, ordinal)
                if (!isValid)
                    this._amountInvalidDataItems++;
                let keyString: string = oldGridData[i].Id;
                //if (ordinal > DataTypes.boolean)
                //    keyString = this._convertToKeyString(oldGridData[i].Key, ordinal);
                newGridData.push({
                    Value: oldGridData[i].Value,
                    Id: keyString,
                    DisplayText: oldGridData[i].DisplayText,
                    Translations: oldGridData[i].Translations,
                    isValid: isValid
                });
            }
            this._enabled = true;
        } else {
            this._enabled = false;
        }
        this.setState({ currentDataType: ordinal, gridData: newGridData }, () => { this._afterGridDataChange() });
    }

    private _isValidValue = (key: any, ordinal: number) => {
        if (!Helper.hasValue(key)) {
            return true;
        }
        let type = typeof (key);
        let isValidString = (ordinal === 0);
        let isValidInteger = ((ordinal === 1) && (this._isInteger(key)) && (type === "number"));
        let isValidFloat = ((ordinal === 2) && (type === "number"));
        let isValidBoolean = ((ordinal === 3) && (type === "boolean"));
        let isValidDateTime = ((ordinal === 4) && (key instanceof Date) && (type !== "number"));
        let isValidDate = ((ordinal === 5) && (key instanceof Date) && (type !== "number") && (this._isDate(key)));
        return (isValidString || isValidInteger || isValidFloat || isValidBoolean || isValidDateTime || isValidDate);
    }

    private _isInteger = (key: number) => {
        return (key % 1 == 0);
    }

    private _isDate = (key: Date) => {
        const hour = key.getHours();
        const minutes = key.getMinutes();
        const seconds = key.getSeconds();
        return (hour == 0 && minutes == 0 && seconds == 0)
    }

    private _createDialog = () => {
        return (
            <div>
                <Dialog {...this._dialogProps} open={this.state.dialogOpen} >
                    <FullHeightContainer>
                        {this._createIdTextBox()}
                        {this._createValueBox()}
                        {this._createDisplayTextTextBox()}
                        <CRTranslationsDialog
                            data={this.state.currentDataItem.Translations}
                            onOkClick={this._handleNewTranslations}
                        />
                    </FullHeightContainer>
                </Dialog>
            </div>
        );
    }

    private _handleNewTranslations = (values: CRTranslation[]) => {
        let item = this.state.currentDataItem;
        item.Translations = values;
        this.setState({ currentDataItem: item });
    }

    private _openDialog = (dataItem: CRKeyValue = null) => {
        if (Helper.hasValue(dataItem)) {
            for (let i = 0; i < this.state.gridData.length; i++) {
                if (dataItem.Id == this.state.gridData[i].Id) {
                    this._oldId = i;
                    break;
                }
            }
        } else {
            this._oldId = null;
            dataItem = {
                isValid: false,
                Value: null,
                Id: "",
                Translations: null,
                DisplayText: ""
            };
        }
        if (!dataItem.isValid) {
            switch (this.state.currentDataType) {
                case DataTypes.string:
                    dataItem.Value = "";
                    break;
                case (DataTypes.int):
                case (DataTypes.float):
                    dataItem.Value = 0;
                    break;
                case (DataTypes.boolean):
                    dataItem.Value = false;
                    break;
                case (DataTypes.date):
                case (DataTypes.dateTime):
                    const d = new Date();
                    dataItem.Value = new Date(d.getFullYear(), d.getMonth(), d.getDay());
                    break;
            }
        }
        this.setState({ currentDataItem: dataItem, dialogOpen: true });
    }

    private _createValueBox = () => {
        let element;
        let value: any = null;//.Value;
        if (Helper.hasValue(this.state.currentDataItem.Value)) {
            value = this.state.currentDataItem.Value;
        }
        switch (this.state.currentDataType) {
            case DataTypes.string:
                let textBoxProps = this._factory.getDefaultTextBoxProps();
                textBoxProps.value = Helper.getValueOrDefault(value, "");
                textBoxProps.onChange = this._handleKeyBoxtextChange;
                element = (<><TextBox {...textBoxProps} /></>);
                break;
            case DataTypes.int:
            case DataTypes.float:
                let numericTextBoxProps = this._factory.getDefaultNumericTextBoxProps();
                numericTextBoxProps.value = value;
                if (this.state.currentDataType == DataTypes.int) {
                    numericTextBoxProps.field.decimals = 0;
                    numericTextBoxProps.field.format = "0";
                }
                numericTextBoxProps.onChange = this._handleKeyBoxtextChange;
                element = (<><IsNumericTextBox {...numericTextBoxProps} /></>);
                break;
            case DataTypes.boolean:
                let checkBoxProps = this._factory.getDefaultCheckBoxProps();
                checkBoxProps.value = Helper.getValueOrDefault(value, false);
                checkBoxProps.onChange = this._handleKeyBoxtextChange;
                element = (<><CheckBox {...checkBoxProps} /></>);
                break;
        }
        return (
            <FieldInstance
                label="Value"
                noHover={true}>
                {element}
            </FieldInstance>
        );
    }

    private _createIdTextBox = () => {
        let textBoxProps = this._factory.getDefaultTextBoxProps();
        textBoxProps.value = Helper.getValueOrDefault(this.state.currentDataItem.Id, "");
        textBoxProps.onChange = (field: { model: string }, value: any, dataItem?: any) => {
            let item = this.state.currentDataItem;
            item.Id = value;
            this.setState({ currentDataItem: item });
        }
        return (
            <FieldInstance label="Id*" noHover={true}>
                <TextBox {...textBoxProps} />
            </FieldInstance>
        );

    }

    private _createDisplayTextTextBox = () => {
        let textBoxProps = this._factory.getDefaultTextBoxProps();
        textBoxProps.value = Helper.getValueOrDefault(this.state.currentDataItem.DisplayText, "");
        textBoxProps.onChange = (field: { model: string }, value: any, dataItem?: any) => {
            let item = this.state.currentDataItem;
            item.DisplayText = value;
            this.setState({ currentDataItem: item });
        }
        return (
            <FieldInstance label="DisplayText" noHover={true}>
                <TextBox {...textBoxProps} />
            </FieldInstance>
        );

    }

    private _handleKeyBoxtextChange = (field: { model: string }, value: any, dataItem?: any) => {
        let item = this.state.currentDataItem;
        item.Value = value;
        this.setState({ currentDataItem: item });
    }

    private _deleteAllInvalid = () => {
        DialogHelper.confirm(Helper.getTranslation("Standard.Msg.Loeschen")).then(isOk => {
            if (isOk) {
                let gridData = this.state.gridData.filter(f => f.isValid);
                this.setState({ gridData: gridData }, () => { this._afterGridDataChange(); });
            }
        });
    }

    private _delete = (dataItem: CRKeyValue) => {
        DialogHelper.confirm(Helper.getTranslation("Standard.Msg.Loeschen")).then(isOk => {
            if (isOk) {
                let gridData = this.state.gridData.filter(f => f.Value !== dataItem.Value);
                this.setState({ gridData: gridData }, () => { this._afterGridDataChange() });
            }
        });
    }

    private _createGrid = () => {
        let fullLoaded: boolean = Helper.hasValue(this.state.gridData) && Helper.hasValue(this._gridOptions);
        if (fullLoaded) {
            const standardButtons: Array<ToolBarStandardButton> = [];
            standardButtons.push({ type: ToolBarStandardButtonType.NEW, caption: Config.translations.newLabel, enabled: this._enabled });
            standardButtons.push({ type: ToolBarStandardButtonType.EDIT, caption: Config.translations.editLabel, enabled: this._enabled });
            standardButtons.push({ type: ToolBarStandardButtonType.DELETE, caption: Config.translations.deleteLabel, enabled: this._enabled });
            const customButtons: Array<GridCustomToolBarButton> = [];
            customButtons.push({
                autoEnabledOnRecordSelected: false,
                caption: Helper.getTranslation("WebSMS.Report.Question.DeleteInvalid"),
                enabled: ((this._amountInvalidDataItems > 0) && this._enabled),
                iconClass: "k-i-trash",
                id: "DeleteInValid"
            });

            let grid = (
                <Grid data={this.state.gridData}
                    options={this._gridOptions}
                    id="customReportQuestionPossibleValuesGrid"
                    onSelectionChanged={this._onSelectedChange}
                    standardButtons={standardButtons}
                    onClickStandardButton={this._handleClickStandardButton}
                    customButtons={customButtons}
                    onClickCustomButton={this._handleClickCustomButton}
                    onDataBound={this._handleDataBound}
                />
            );
            return (
                <div style={{ height: "300px" }}>
                    {grid}
                </div>
            )
        } else {
            return (<></>);
        }
    }

    private _handleClickStandardButton = (type: ToolBarStandardButtonType, dataItem: CRKeyValue) => {
        switch (type) {
            case ToolBarStandardButtonType.EDIT:
                this._openDialog(dataItem);
                break;
            case ToolBarStandardButtonType.NEW:
                this._openDialog();
                break;
            case ToolBarStandardButtonType.DELETE:
                this._delete(dataItem);
                break;

        }
    }

    private _onSelectedChange = (dataItem: any) => {
    }

    private _handleClickCustomButton = (id: string, dataItem: any) => {
        switch (id) {
            case "DeleteInValid":
                this._deleteAllInvalid();
                break;
        }
    }

    private _handleDataBound = (e) => {
        let data = e.sender.dataSource.view();
        for (let i = 0; i < data.length; i++) {
            if (!data[i].isValid) {
                var row = e.sender.tbody.find("tr[data-uid='" + data[i].uid + "']");
                var cell = $("td", row);
                cell.css("background-color", "#d50000");
                cell.css("color", "white");
            }
        }
    }

    private _setEvents = () => {
        let sheet = General.Sheet.Manager.getTopMostSheet();
        sheet.bind(SheetEventType.Custom, (cus) => {
            if (cus.command === "dataTypeChanged") {
                this._updateDataType(cus.value);
            } else if (cus.command === "entityStatusChanged") {
                this._changeGridStatus(cus.value);
            }
        });
    }

    componentDidMount() {
        this._enabled = !this.props.disabled;
        this._gridOptions = this.props.context.possibleValuesGridOptions;
        let dataType = this.props.entity.DataType;
        let gridData: CRKeyValue[] = [];
        for (let i = 0; i < this.props.value.length; i++) {
            gridData.push({
                Id: this.props.value[i].Id,
                Value: this.props.value[i].Value,
                DisplayText: this.props.value[i].DisplayText,
                Translations: this.props.value[i].Translations,
                isValid: true
            });
        }
        this.setState({ currentDataType: dataType, gridData: gridData });
    }

    componentDidUpdate() {
        if (this._enabled === this.props.disabled) {
            this._enabled = !this.props.disabled;
            this.setState({})
        }
    }

    render() {
        const grid = this._createGrid();
        const dialog = this.state.dialogOpen ? this._createDialog() : <></>;
        return (
            <>
                {grid}
                {dialog}
            </>);
    }
};

interface PossibleValuesGridProps {
    context: CRQuestionContext;
    entity: CRQuestionEntity;
    value: CRKeyValuePair[];
    disabled: boolean;
}

interface PossibleValuesGridState {
    gridData: CRKeyValue[];
    currentDataType: DataTypes;
    dialogOpen: boolean;
    currentDataItem: CRKeyValue;
}

interface CRKeyValue {
    Id: string;
    Value: any;
    DisplayText: string;
    Translations: CRTranslation[];
    isValid: boolean;
}